<template>
	<div class="app-cta-container app-cta-container-mobile">
		<a
			v-if="showButton"
			:href="appUrl"
			@click="onButtonClick"
			class="app-cta-button is-mobile"
			target="_blank"
			title="Get the WordFinder App"
		>
			<span class="button-text">
				GET THE APP
			</span>
			<span class="wficon-mobile"></span>
		</a>
	</div>
</template>

<script>
export default {
	data() {
		return {
			appUrl: "",
		};
	},
	computed: {
		showButton() {
			return this.appUrl.length > 0;
		},
	},
	methods: {
		onButtonClick() {
			this.$store.dispatch("trackEvent", {
				ga: this.$ga,
				eventCategory: "App CTA",
				eventAction: "Click mobile button",
			});
		},
	},
	mounted() {
		if (typeof window.navigator === "undefined") return false;

		const agent = window.navigator.userAgent;
		const isAndroid = new RegExp("Android", "i").test(agent);
		const isIos = new RegExp(
			"\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
			"i"
		).test(agent);

		if (isIos || isAndroid) {
			this.appUrl = "https://wordfinder.page.link/app";
		}
	},
};
</script>

<style lang="scss" scoped src="./buttons.scss"></style>
